/* __next_internal_client_entry_do_not_use__ Exclamation auto */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import React from "react";
import { createSVGIcon } from "../util";
/**
 * @figma designed by Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5%3A1608))
 * @trackcomponent
 * @lastsynced 2023-07-10T21:44:59.682Z
 */ export var Exclamation = createSVGIcon(/*#__PURE__*/ _jsxs(_Fragment, {
    children: [
        /*#__PURE__*/ _jsx("path", {
            d: "M0.856934 12C0.856934 14.9553 2.03091 17.7895 4.1206 19.8792C6.21029 21.9689 9.04452 23.1429 11.9998 23.1429C14.9551 23.1429 17.7893 21.9689 19.879 19.8792C21.9687 17.7895 23.1426 14.9553 23.1426 12C23.1426 9.04473 21.9687 6.21051 19.879 4.12081C17.7893 2.03112 14.9551 0.857147 11.9998 0.857147C9.04452 0.857147 6.21029 2.03112 4.1206 4.12081C2.03091 6.21051 0.856934 9.04473 0.856934 12V12Z",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M12 6V11.1429",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M11.1431 16.2857C11.1431 16.5131 11.2334 16.7311 11.3941 16.8918C11.5549 17.0526 11.7729 17.1429 12.0002 17.1429C12.2275 17.1429 12.4456 17.0526 12.6063 16.8918C12.767 16.7311 12.8574 16.5131 12.8574 16.2857C12.8574 16.0584 12.767 15.8404 12.6063 15.6796C12.4456 15.5189 12.2275 15.4286 12.0002 15.4286C11.7729 15.4286 11.5549 15.5189 11.3941 15.6796C11.2334 15.8404 11.1431 16.0584 11.1431 16.2857Z",
            fill: "currentColor",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    ]
}), "Exclamation", {
    viewBox: "0 0 24 24",
    fill: "none",
    color: Core.icon.default
} // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
